export const ReactSimplePeerStatus: { [key: string]: string } = {
  IDLE: 'Waiting for peers',
  EMITTING_OFFER: 'Emitting offer',
  REQUESTING_ACCESS: 'Requesting access',
  RECEIVING_RESPONSE_ACCESS: 'Receiving response access',
  CONNECTING_TO_EXISTING_PEERS: 'Connecting to existing peers',
  JOINING_SESSION: 'Joining session',
};
